import styled from "styled-components"; 

export const ContainerChildren = styled.div`
    display: flex;
`;